import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FavoriteItem, ReferralsState } from "./index.types";

const initialState: ReferralsState = {
  unfavoritedReferrals: [],
};

export const referralsSlice = createSlice({
  name: "referrals",
  initialState,
  reducers: {
    // Used to inform the referrals section which referrals are unfavorited.
    addUnfavoritedReferral: (state, action: PayloadAction<FavoriteItem>) => {
      state.unfavoritedReferrals.push(action.payload);
    },
    resetUnfavoritedReferrals: (state) => {
      state.unfavoritedReferrals = [];
    },
  },
});

export const { addUnfavoritedReferral, resetUnfavoritedReferrals } = referralsSlice.actions;

export const selectUnfavoritedReferrals = (state: any) => state.referrals.unfavoritedReferrals;

export default referralsSlice.reducer;
